import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=3539a023&scoped=true"
import script from "./ProductService.vue?vue&type=script&lang=js"
export * from "./ProductService.vue?vue&type=script&lang=js"
import style0 from "./ProductService.vue?vue&type=style&index=0&id=3539a023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539a023",
  null
  
)

export default component.exports